import React from 'react';
import PropTypes from 'prop-types';

import CommonModal from 'components/elements/modals/CommonModal';

import './DisconnectShopifyModal.css';

const DisconnectShopifyModal = ({ open, onClose, onDisconnect }) => (
  <CommonModal
    className="disconnect-shopify-modal__component"
    open={open}
    onClose={onClose}
  >
    <div className="wrapper">
      <div className="text-content">
        <strong>
          Attention! Your Shopify integration will be disconnected
          from your HeyLink.me page. You can't undo this action.
        </strong>
        <div>Are you sure you would like to proceed?</div>
      </div>
      <div className="buttons-block">
        <div
          className="modal-button"
          onClick={onDisconnect}
          role="button"
          tabIndex={-1}
        >
          <div>
            <div>Yes, remove</div>
            <div>Shopify integration</div>
          </div>
        </div>
        <div
          className="modal-button"
          onClick={onClose}
          role="button"
          tabIndex={-1}
        >
          <div>Not now</div>
        </div>
      </div>
    </div>
  </CommonModal>
);

DisconnectShopifyModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDisconnect: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

DisconnectShopifyModal.defaultProps = {
  open: null,
};

export default DisconnectShopifyModal;
